"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_STATUS = void 0;
// eslint-disable-next-line @typescript-eslint/class-name-casing
exports.PROJECT_STATUS = {
    LEAD: { ID: 1, NAME: 'Lead' },
    PROPOSAL: { ID: 2, NAME: 'Proposal' },
    LOST: { ID: 3, NAME: 'Lost' },
    ACTIVE: { ID: 4, NAME: 'Active' },
    COMPLETED: { ID: 5, NAME: 'Completed' },
    ARCHIVED: { ID: 6, NAME: 'Archived' },
};
